module.exports = __webpack_public_path__ + "static/media/empty_shopcard.ada1205a.jpg";